export default __webpack_public_path__ + "static/okr-transparency-05faf63b4f2e1c536944f39fe4b7b44a.mp4";